import * as React from "react";
import IGAFContactProps from "./IGAFContact";
import "../../../assets/sass/widgets/gafContact.scss";
import ReactGA from "react-ga";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { RootState } from "../../rootReducer";
import * as dynamicFormActionCreators from "../../components/DynamicForm/actionCreators";
import { imagePathurl } from "../../utils/utils";

/**
 * @class GAFContact
 * @param props
 * @constructor
 * @category Widgets
 * @description This component renders the GAF contact information popup  while tapping on the contact gaf button
 */

class GAFContact extends React.Component<IGAFContactProps, {}> {
    constructor(props) {
        super(props);
    }

    onContactGafClick = () => {
        this.props.toggleTechSupportPopUp(true);
        document.body.classList.add("hideOverflow");
        const tabElement = document.querySelector(".nav-menu-item.active div.nav-label");
        const currTab = (tabElement && tabElement.textContent) || "";
        ReactGA.event({
            category: "Contact GAF",
            action: "Contact GAF: View Contact Info",
            label: `Contact GAF: View Contact Info: ${currTab}`,
        });
    };

    render() {
        const { screenResolution } = this.props;
        //image CDN_PATH
        const getimagePath = imagePathurl();
        return (
            <>
                <div className="gaf-contact">
                    <img className="gaf-building-img" src={`${getimagePath}GAFBuilding.jpg`} alt="gaf-contact" />
                    <div className="gaf-label">Questions or Feedback?</div>
                    {screenResolution.width >= 768 && (
                        <div className="gaf-button" onClick={this.onContactGafClick}>
                            CONTACT GAF
                        </div>
                    )}
                </div>
            </>
        );
    }
}

function mapStateToProps(state: RootState) {
    return {
        screenResolution: state.globalInfo.screenResolution,
    };
}

function mapDispatchToProps(dispatch: Dispatch) {
    return {
        toggleTechSupportPopUp: bindActionCreators(dynamicFormActionCreators.toggleTechSupportPopUp, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(GAFContact);
